import React from "react";
import AssessmentSubHeader from "../components/assessment/AssessmentSubHeader";
import StepperBar          from "../components/assessment/StepperBar";
import QuestionTable       from "../components/assessment/QuestionTable";
import AssessmentFooter    from "../components/assessment/AssessmentFooter";
import preloadimg from "../assets/preloader1.gif";

const AssessmentPage = ({
  selectedType,
  toolName,
  sections,
  apiSections,
  reportIdx,
  currentSectionIdx,
  answers,
  completion,
  reportUnlocked,
  loading,
  error,
  updateAnswer,
  goToSection,
  goNext,
  goPrev,
  onBack,
  onSaveAsDraft,
  onSubmit,
  showDraftToast,
  showErrorToast,   // ✅ NEW
  isSubmitting,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-white">
        <img src={preloadimg} alt="Loading" className="w-44 mb-6" />
        <p className="text-gray-600 text-base font-medium tracking-wide">
          Loading questions...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 80px)", gap: "12px" }}>
        <div style={{ fontSize: "16px", color: "#ef4444" }}>{error}</div>
        <button onClick={onBack} style={{ background: "#bb1ccc", color: "white", border: "none", borderRadius: "6px", padding: "10px 24px", cursor: "pointer", fontWeight: "700" }}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div style={{ background: "white", minHeight: "calc(100vh - 80px)", fontFamily: "'Segoe UI', Arial, sans-serif" }}>

      {/* ── Submitting overlay ── */}
      {isSubmitting && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 99999,
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(4px)",
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          gap: "20px",
        }}>
        <img src={preloadimg} width="200" />
          <div style={{ fontSize: "18px", fontWeight: "700", color: "#1e293b" }}>
            Submitting Assessment...
          </div>
          <div style={{ fontSize: "13px", color: "#64748b" }}>
            Please wait, do not close this page.
          </div>
          <style>{`
            @keyframes spin {
              0%   { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}

      {/* ── Draft saved toast (success) ── */}
      {showDraftToast && (
        <div style={{
          position: "fixed", bottom: "90px", right: "24px", zIndex: 9999,
          background: "#1e1e2e", color: "white", borderRadius: "8px",
          padding: "14px 18px", minWidth: "260px",
          display: "flex", alignItems: "center", gap: "10px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.35)",
          fontSize: "14px", fontWeight: "600", overflow: "hidden"
        }}>
          <span style={{
            background: "#22c55e", borderRadius: "50%",
            width: "24px", height: "24px", display: "flex",
            alignItems: "center", justifyContent: "center",
            fontSize: "13px", flexShrink: 0
          }}>✓</span>
          Saved As Draft Successfully.
          <div style={{
            position: "absolute", bottom: 0, left: 0,
            height: "3px", background: "#22c55e",
            animation: "toastShrink 3.5s linear forwards"
          }} />
        </div>
      )}

      {/* ── Draft error toast ── */}
      {showErrorToast && (
        <div style={{
          position: "fixed", bottom: "90px", right: "24px", zIndex: 9999,
          background: "#1e1e2e", color: "white", borderRadius: "8px",
          padding: "14px 18px", minWidth: "260px",
          display: "flex", alignItems: "center", gap: "10px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.35)",
          fontSize: "14px", fontWeight: "600", overflow: "hidden"
        }}>
          <span style={{
            background: "#ef4444", borderRadius: "50%",
            width: "24px", height: "24px", display: "flex",
            alignItems: "center", justifyContent: "center",
            fontSize: "13px", flexShrink: 0
          }}>✕</span>
          Failed to save. Please try again.
          <div style={{
            position: "absolute", bottom: 0, left: 0,
            height: "3px", background: "#ef4444",
            animation: "toastShrink 4s linear forwards"
          }} />
        </div>
      )}

      <AssessmentSubHeader
        selectedType={selectedType}
        toolName={toolName}
        completion={completion}
        onBack={onBack}
      />
      <StepperBar
        sections={sections}
        currentIdx={currentSectionIdx}
        reportIdx={reportIdx}
        reportUnlocked={reportUnlocked}
        onStepClick={goToSection}
      />
      <QuestionTable
        apiSections={apiSections}
        sections={sections}
        currentSectionIdx={currentSectionIdx}
        reportIdx={reportIdx}
        answers={answers}
        reportUnlocked={reportUnlocked}
        completion={completion}
        onAnswer={updateAnswer}
      />
      <AssessmentFooter
        sections={sections}
        currentSectionIdx={currentSectionIdx}
        reportIdx={reportIdx}
        reportUnlocked={reportUnlocked}
        onPrev={goPrev}
        onNext={goNext}
        onSaveAsDraft={onSaveAsDraft}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default AssessmentPage;